export var AdTechnologyType = /*#__PURE__*/ function(AdTechnologyType) {
    AdTechnologyType["CSAI"] = "CSAI";
    AdTechnologyType["SSAI_MEDIATAILOR"] = "SSAI MEDIATAILOR";
    AdTechnologyType["SSAI_YOSPACE"] = "SSAI YOSPACE";
    AdTechnologyType["NA"] = "NA";
    AdTechnologyType["CSAI_PREROLL"] = "CSAI PREROLL";
    return AdTechnologyType;
}({});
export var ContentDescriptorEnum = /*#__PURE__*/ function(ContentDescriptorEnum) {
    ContentDescriptorEnum["Linear"] = "Linear";
    ContentDescriptorEnum["NonEpisodicVod"] = "NonEpisodicVod";
    ContentDescriptorEnum["EpisodicVod"] = "EpisodicVod";
    ContentDescriptorEnum["Sle"] = "Sle";
    ContentDescriptorEnum["Fer"] = "Fer";
    ContentDescriptorEnum["ShortForm"] = "ShortForm";
    ContentDescriptorEnum["Trailer"] = "Trailer";
    return ContentDescriptorEnum;
}({});
export var LegacyVideoQuality = /*#__PURE__*/ function(LegacyVideoQuality) {
    LegacyVideoQuality[LegacyVideoQuality["Hd"] = 0] = "Hd";
    LegacyVideoQuality[LegacyVideoQuality["Sd"] = 1] = "Sd";
    LegacyVideoQuality[LegacyVideoQuality["Uhd"] = 2] = "Uhd";
    return LegacyVideoQuality;
}({});
export var LegacyDrmType = /*#__PURE__*/ function(LegacyDrmType) {
    LegacyDrmType[LegacyDrmType["PlayReady"] = 0] = "PlayReady";
    LegacyDrmType[LegacyDrmType["Widevine"] = 1] = "Widevine";
    LegacyDrmType[LegacyDrmType["Marlin"] = 2] = "Marlin";
    LegacyDrmType[LegacyDrmType["Fairplay"] = 3] = "Fairplay";
    return LegacyDrmType;
}({});

//# sourceMappingURL=shared.enums.js.map